import { render, staticRenderFns } from "./addKomersial.vue?vue&type=template&id=32ef61b1&scoped=true&"
import script from "./addKomersial.vue?vue&type=script&lang=js&"
export * from "./addKomersial.vue?vue&type=script&lang=js&"
import style0 from "./addKomersial.vue?vue&type=style&index=0&id=32ef61b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ef61b1",
  null
  
)

export default component.exports